import styled, {css} from 'styled-components'

export const StyledFormSection = styled.div<{$fullWidth?: boolean}>(
    ({theme: {spacing}, $fullWidth}) => css`
        display: grid;
        /* minmax(0, 1fr): a bare 1fr track has min-width: auto, so a long nowrap value
           would widen the column past the page instead of truncating. */
        grid-template-columns: 352px minmax(0, 1fr);
        margin-bottom: ${spacing * 4}px;
        width: ${$fullWidth ? '100%' : 'auto'};
    `
)
